module.exports = __webpack_public_path__ + "static/media/FD5.7166a26d.jpg";